(function () {
  const config = window.EOMChatbotConfig || {};
  const rules = window.EOMChatbotRules || {};
  const routes = config.routes || {};
  const rootId = "eom-chatbot-root";
  const storageKey = "eom_chatbot_transcript_v1";
  const maxTranscriptItems = 30;

  const state = {
    flow: null,
    flowStep: null,
    flowData: {},
    transcript: [],
    botQueue: Promise.resolve(),
    hasAutoCollapsedQuickHelp: false,
    userHasInteracted: false
  };

  function init() {
    const root = document.getElementById(rootId);
    if (!root) return;

    root.innerHTML = [
      '<button class="eom-chat-launcher" type="button" aria-label="Open EarthOnMall chat" aria-expanded="false" aria-controls="eom-chat-panel">',
      `
      <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 949.65 979.87">
        <defs>
          <style>
            .chatbot-icon-0 {
              fill: url(#Foliage_111);
            }

            .chatbot-icon-1 {
              fill: url(#Foliage_11);
            }
          </style>
          <linearGradient id="Foliage_11" data-name="Foliage 11" x1="276.27" y1="629.99" x2="949.65" y2="629.99" gradientUnits="userSpaceOnUse">
            <stop offset=".02" stop-color="#52835f"/>
            <stop offset=".5" stop-color="#006d4f"/>
            <stop offset="1" stop-color="#004a33"/>
          </linearGradient>
          <linearGradient id="Foliage_111" data-name="Foliage 11" x1="0" y1="398.1" x2="765.92" y2="398.1" xlink:href="#Foliage_11"/>
        </defs>
        <path class="chatbot-icon-1" d="M949.65,521.08l-.02,21.95-.59,8.11c-3.21,54.24-21.03,105.8-50.47,151.5-26.56,41.01-61.17,75.66-101.94,103.57l-.1,173.66-171.81-105.74c-43.76,7.4-88.04,8.3-132.12,2.32-54.93-7.4-106.32-26.98-152.19-57.85-22.98-15.61-43.89-32.64-64.14-52.87l98.75-.26c82.42-.21,168.32-19.4,241.15-58.32,100.41-53.65,172.4-142.56,199.24-253.76,8.86-36.73,12.83-73.56,11.9-111.35l-1.53-61.96c68.05,56,116.38,138.69,122.77,226.03l1.09,14.96Z"/>
        <path class="chatbot-icon-0" d="M416,0l6.14.92c130.88,9.46,256.35,95.27,313.03,213.89,23.24,48.64,33.48,101.25,30.13,155.17-8.38,135.05-87.27,250.29-211.72,303.7-48.19,20.73-99.87,30.28-152.57,30.75-35.78-.54-70.55-3.38-105.75-8.04l-172.38,99.82-.09-173.77c-49.88-41.95-86.27-96.64-105.54-158.58-8.81-27.99-13.57-55.98-15.95-85l-.41-16.01-.9-1.84.2-22.94c.9-5.07.7-10.2,1.2-15.91C12.03,200.69,91.34,101.66,198.19,47.16,249.18,21.16,304.4,6.31,361.28,1.5l15.72-1.5h39ZM245.26,352.09c0-25.34-20.54-45.88-45.88-45.88s-45.88,20.54-45.88,45.88,20.54,45.88,45.88,45.88,45.88-20.54,45.88-45.88ZM428.96,352.11c0-25.33-20.53-45.87-45.87-45.87s-45.87,20.53-45.87,45.87,20.53,45.87,45.87,45.87,45.87-20.53,45.87-45.87ZM612.75,352.09c0-25.33-20.54-45.87-45.87-45.87s-45.87,20.54-45.87,45.87,20.54,45.87,45.87,45.87,45.87-20.54,45.87-45.87Z"/>
      </svg>
      `
      ,
      "</button>",
      '<section class="eom-chat-panel" id="eom-chat-panel" aria-label="EarthOnMall chat assistant" data-open="false" data-expanded="false">',
      '<header class="eom-chat-header">',
      '<div>',
      '<h2 class="eom-chat-title">EarthOnMall Help</h2>',
      `<p class="eom-chat-subtitle"><span class="eom-status" data-live="${isBusinessHours()}">${availabilityLabel()}</span></p>`,
      "</div>",
      '<div class="eom-chat-header-actions">',
      `<button class="eom-chat-expand" type="button" aria-label="Expand chat" aria-pressed="false">${expandIcon(false)}</button>`,
      '<button class="eom-chat-close" type="button" aria-label="Close chat">×</button>',
      "</div>",
      "</header>",
      '<div class="eom-chat-log" aria-live="polite"></div>',
      '<div class="eom-chat-quick"></div>',
      '<form class="eom-chat-form">',
      '<input class="eom-chat-input" type="text" autocomplete="off" placeholder="Ask about products, orders, or support..." aria-label="Message" />',
      '<button class="eom-chat-send" type="submit">Send</button>',
      "</form>",
      "</section>"
    ].join("");

    bindEvents(root);
    restoreTranscript(root);
    if (!state.transcript.length) {
      showBotMessage(root, {
        text:
          "Hi, I can help you find nicotine replacement products, compare patches, gum, and lozenges, track orders, review shipping/returns, or create a support request.",
        links: [
          { label: config.claims?.sameDayDispatch || "Same-day dispatch", urlKey: "shippingReturns" },
          { label: config.claims?.freeDelivery || "Free delivery", urlKey: "shippingReturns" },
          { label: config.claims?.returns || "60-day returns", urlKey: "shippingReturns" }
        ]
      });
    }
    renderQuickActions(root);
    track("loaded", { page: location.pathname });
  }

  function bindEvents(root) {
    const launcher = root.querySelector(".eom-chat-launcher");
    const panel = root.querySelector(".eom-chat-panel");
    const close = root.querySelector(".eom-chat-close");
    const expand = root.querySelector(".eom-chat-expand");
    const form = root.querySelector(".eom-chat-form");
    const input = root.querySelector(".eom-chat-input");

    launcher.addEventListener("click", () => {
      const open = panel.getAttribute("data-open") !== "true";
      panel.setAttribute("data-open", String(open));
      launcher.setAttribute("aria-expanded", String(open));
      if (open) {
        track("opened", { page: location.pathname });
      }
    });

    close.addEventListener("click", () => {
      panel.setAttribute("data-open", "false");
      launcher.setAttribute("aria-expanded", "false");
      track("closed", { page: location.pathname });
    });

    expand.addEventListener("click", () => {
      const expanded = panel.getAttribute("data-expanded") !== "true";
      panel.setAttribute("data-expanded", String(expanded));
      expand.setAttribute("aria-label", expanded ? "Collapse chat" : "Expand chat");
      expand.setAttribute("aria-pressed", String(expanded));
      expand.innerHTML = expandIcon(expanded);
      track(expanded ? "expanded" : "collapsed", { page: location.pathname });
    });

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const message = input.value.trim();
      if (!message) return;
      input.value = "";
      handleUserMessage(root, message);
    });

    root.addEventListener("click", (event) => {
      const actionButton = event.target.closest("[data-eom-action]");
      if (!actionButton) return;
      event.preventDefault();
      handleAction(root, actionButton.getAttribute("data-eom-action"), actionButton.textContent.trim());
    });
  }

  function handleUserMessage(root, message) {
    state.userHasInteracted = true;
    addUserMessage(root, message);
    track("message_sent", { length: message.length });

    if (state.flow === "ticket") {
      showBotMessage(root, {
        text:
          "Use the support request form below so the team receives the right details. Avoid payment card numbers, passwords, and sensitive medical details."
      });
      renderTicketForm(root);
      return;
    }

    const matched = matchIntent(message);
    if (matched) {
      track("intent_matched", { intent: matched.id });
      showBotMessage(root, resolveReply(matched.reply));
      return;
    }

    showBotMessage(root, resolveReply(rules.fallback || {}));
  }

  function handleAction(root, action, label) {
    state.userHasInteracted = true;
    track("action_clicked", { action, label });

    if (action.startsWith("intent:")) {
      const intentId = action.replace("intent:", "");
      const intent = (rules.intents || []).find((item) => item.id === intentId);
      if (intent) {
        addUserMessage(root, label);
        showBotMessage(root, resolveReply(intent.reply));
      }
      return;
    }

    if (action.startsWith("flow:")) {
      const flowId = action.replace("flow:", "");
      addUserMessage(root, label);
      startFlow(root, flowId);
    }
  }

  function startFlow(root, flowId) {
    const flow = rules.flows?.[flowId];
    if (!flow) return;
    state.flow = flowId;
    state.flowStep = flow.steps ? flow.steps[0]?.id : null;
    state.flowData = {};

    showBotMessage(root, { text: flow.intro || "Let's start." }).then(() => {
      if (flowId === "ticket") {
        delayBotReply(root, () => renderTicketForm(root));
      } else {
        renderFlowStep(root, flow);
      }
    });
  }

  function renderFlowStep(root, flow) {
    const step = flow.steps.find((item) => item.id === state.flowStep);
    if (!step) return;
    delayBotReply(root, () => {
      addBotMessage(root, {
        text: step.question,
        links: step.options.map((option) => ({
          label: option.label,
          action: `flowstep:${flow.id}:${step.id}:${option.value}`
        }))
      });

      root.querySelectorAll('[data-eom-action^="flowstep:"]').forEach((button) => {
        button.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            const [, flowId, stepId, value] = button.getAttribute("data-eom-action").split(":");
            handleFlowStep(root, flowId, stepId, value, button.textContent.trim());
          },
          { once: true }
        );
      });
    });
  }

  function handleFlowStep(root, flowId, stepId, value, label) {
    const flow = rules.flows?.[flowId];
    const step = flow?.steps.find((item) => item.id === stepId);
    const option = step?.options.find((item) => item.value === value);
    if (!flow || !step || !option) return;

    addUserMessage(root, label);
    state.flowData[stepId] = value;

    const afterOptionReply = option.reply
      ? showBotMessage(root, { text: option.reply })
      : Promise.resolve();

    if (option.end || option.endByPrevious) {
      const previous = state.flowData.style;
      const links = option.end?.links || option.endByPrevious?.[previous] || [];
      afterOptionReply.then(() => showBotMessage(root, {
        text:
          "Here is the best next step. Please remember to read and follow the exact product label before use.",
        links
      }));
      state.flow = null;
      state.flowStep = null;
      return;
    }

    state.flowStep = option.next;
    afterOptionReply.then(() => renderFlowStep(root, flow));
  }

  function renderTicketForm(root) {
    const flow = rules.flows?.ticket;
    const fields = flow?.fields || [];
    const wrapper = document.createElement("div");
    wrapper.className = "eom-chat-message eom-chat-message--bot";
    wrapper.innerHTML = [
      '<form class="eom-ticket">',
      `<p class="eom-ticket-note">${escapeHtml(config.responsePromise || "")}</p>`,
      fields
        .map((field) => {
          if (field.options) {
            return [
              `<label>${escapeHtml(field.label)}`,
              `<select name="${field.id}" ${field.required ? "required" : ""}>`,
              '<option value="">Select a reason</option>',
              field.options.map((option) => `<option>${escapeHtml(option)}</option>`).join(""),
              "</select></label>"
            ].join("");
          }
          if (field.id === "message") {
            return `<label>${escapeHtml(field.label)}<textarea name="${field.id}" ${field.required ? "required" : ""}></textarea></label>`;
          }
          return `<label>${escapeHtml(field.label)}<input name="${field.id}" ${field.id === "email" ? 'type="email"' : 'type="text"'} ${field.required ? "required" : ""} /></label>`;
        })
        .join(""),
      '<p class="eom-ticket-note">For damaged, missing, or wrong items, mention whether you have photos of the product, packing slip, shipping label, and packaging.</p>',
      '<button class="eom-chat-send" type="submit">Create ticket</button>',
      '<p class="eom-ticket-note eom-ticket-status"></p>',
      "</form>"
    ].join("");

    const log = root.querySelector(".eom-chat-log");
    log.appendChild(wrapper);
    log.scrollTop = log.scrollHeight;

    wrapper.querySelector("form").addEventListener("submit", (event) => {
      event.preventDefault();
      submitTicket(root, event.currentTarget);
    });
  }

  async function submitTicket(root, form) {
    const data = Object.fromEntries(new FormData(form).entries());
    const status = form.querySelector(".eom-ticket-status");
    const subject = `[Chatbot] ${data.reason || "Support request"}${data.order ? ` - ${data.order}` : ""}`;
    const body = [
      `Reason: ${data.reason || ""}`,
      `Name: ${data.name || ""}`,
      `Email: ${data.email || ""}`,
      `Order number: ${data.order || ""}`,
      `Shipping ZIP/postal code: ${data.zip || ""}`,
      "",
      data.message || "",
      "",
      `Page: ${location.href}`,
      `Availability shown: ${availabilityLabel()}`
    ].join("\n");

    track("ticket_submitted_attempt", { reason: data.reason || "unknown" });

    try {
      const payload = new FormData();
      payload.append("form_type", "contact");
      payload.append("utf8", "✓");
      payload.append("contact[name]", data.name || "");
      payload.append("contact[email]", data.email || "");
      payload.append("contact[phone]", "");
      payload.append("contact[subject]", subject);
      payload.append("contact[body]", body);

      const response = await fetch("/contact", {
        method: "POST",
        body: payload,
        credentials: "same-origin"
      });

      if (!response.ok) throw new Error("Contact form failed");

      status.textContent =
        "Thanks. Your request has been sent to EarthOnMall support. Please watch your email for next steps.";
      form.querySelector("button").disabled = true;
      track("ticket_submitted", { reason: data.reason || "unknown" });
      state.flow = null;
    } catch (error) {
      const mailto = buildMailto(subject, body, data.email);
      status.innerHTML =
        'I could not submit the form automatically. <a class="eom-chat-link" href="' +
        mailto +
        '">Email support instead</a>';
      status.classList.add("eom-ticket-error");
      track("ticket_submit_failed", { reason: data.reason || "unknown" });
    }
  }

  function matchIntent(message) {
    const text = normalize(message);
    return (rules.intents || [])
      .slice()
      .sort((a, b) => (b.priority || 0) - (a.priority || 0))
      .find((intent) => (intent.keywords || []).some((keyword) => text.includes(normalize(keyword))));
  }

  function resolveReply(reply) {
    const resolved = { ...(reply || {}) };
    if (resolved.quickActions) {
      resolved.links = (config.quickActions || []).map((item) => ({
        label: item.label,
        action: item.action
      }));
    }
    return resolved;
  }

  function addUserMessage(root, text) {
    addMessage(root, { text }, "user");
  }

  function addBotMessage(root, reply) {
    addMessage(root, reply, "bot");
    autoCollapseQuickHelp(root);
  }

  function showBotMessage(root, reply) {
    return delayBotReply(root, () => addBotMessage(root, reply));
  }

  function delayBotReply(root, callback) {
    state.botQueue = state.botQueue.then(
      () =>
        new Promise((resolve) => {
          const log = root.querySelector(".eom-chat-log");
          const typing = document.createElement("div");
          typing.className = "eom-chat-message eom-chat-message--bot";
          typing.setAttribute("data-eom-typing", "true");
          typing.innerHTML = [
            '<div class="eom-chat-typing" aria-hidden="true"><span></span><span></span><span></span></div>',
            `<span class="eom-chat-typing-text">${escapeHtml(config.behavior?.typingLabel || "Typing")}</span>`
          ].join("");
          log.appendChild(typing);
          log.scrollTop = log.scrollHeight;

          window.setTimeout(() => {
            typing.remove();
            callback();
            resolve();
          }, Number(config.behavior?.minimumBotDelayMs || 650));
        })
    );

    return state.botQueue;
  }

  function addMessage(root, reply, sender) {
    const log = root.querySelector(".eom-chat-log");
    const message = document.createElement("div");
    message.className = `eom-chat-message eom-chat-message--${sender}`;
    message.innerHTML = `<p>${escapeHtml(reply.text || "")}</p>${renderLinks(reply.links || reply.followups || [])}`;
    log.appendChild(message);
    log.scrollTop = log.scrollHeight;

    state.transcript.push({ sender, text: reply.text || "", at: Date.now() });
    state.transcript = state.transcript.slice(-maxTranscriptItems);
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(state.transcript));
    } catch (error) {
      // Session transcript storage is optional.
    }
  }

  function renderLinks(links) {
    if (!links.length) return "";
    return `<div class="eom-chat-links">${links
      .map((link) => {
        const label = escapeHtml(link.label || "Open");
        if (link.action) {
          return `<button class="eom-chat-action" type="button" data-eom-action="${escapeHtml(link.action)}">${label}</button>`;
        }
        const url = link.url || routes[link.urlKey] || "#";
        return `<a class="eom-chat-link" href="${escapeHtml(url)}" data-eom-link="${escapeHtml(label)}">${label}</a>`;
      })
      .join("")}</div>`;
  }

  function renderQuickActions(root) {
    const container = root.querySelector(".eom-chat-quick");
    container.innerHTML = [
      '<div class="eom-chat-quick-top">',
      '<p class="eom-chat-quick-label">Quick help</p>',
      '<button class="eom-chat-quick-toggle" type="button" aria-expanded="true">Hide</button>',
      "</div>",
      '<div class="eom-chat-actions">',
      (config.quickActions || [])
        .map(
          (action) =>
            `<button class="eom-chat-action" type="button" data-eom-action="${escapeHtml(action.action)}">${escapeHtml(action.label)}</button>`
        )
        .join(""),
      "</div>"
    ].join("");

    const toggle = container.querySelector(".eom-chat-quick-toggle");
    toggle.addEventListener("click", () => {
      const collapsed = container.getAttribute("data-collapsed") === "true";
      setQuickHelpCollapsed(root, !collapsed);
      track(!collapsed ? "quick_help_collapsed" : "quick_help_expanded", { manual: true });
    });
  }

  function autoCollapseQuickHelp(root) {
    if (!state.userHasInteracted) return;
    if (state.hasAutoCollapsedQuickHelp) return;
    state.hasAutoCollapsedQuickHelp = true;
    window.setTimeout(() => {
      setQuickHelpCollapsed(root, true);
      track("quick_help_collapsed", { automatic: true });
    }, 250);
  }

  function setQuickHelpCollapsed(root, collapsed) {
    const container = root.querySelector(".eom-chat-quick");
    const toggle = root.querySelector(".eom-chat-quick-toggle");
    if (!container || !toggle) return;
    container.setAttribute("data-collapsed", String(collapsed));
    toggle.setAttribute("aria-expanded", String(!collapsed));
    toggle.textContent = collapsed ? "Show" : "Hide";
  }

  function restoreTranscript(root) {
    try {
      state.transcript = JSON.parse(sessionStorage.getItem(storageKey) || "[]");
    } catch (error) {
      state.transcript = [];
    }

    if (!state.transcript.length) return;
    const log = root.querySelector(".eom-chat-log");
    state.transcript.forEach((item) => {
      const message = document.createElement("div");
      message.className = `eom-chat-message eom-chat-message--${item.sender}`;
      message.innerHTML = `<p>${escapeHtml(item.text || "")}</p>`;
      log.appendChild(message);
    });
  }

  function isBusinessHours() {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: config.timezone || "America/Los_Angeles",
      weekday: "short",
      hour: "numeric",
      hour12: false
    }).formatToParts(new Date());
    const weekday = parts.find((part) => part.type === "weekday")?.value;
    const hour = Number(parts.find((part) => part.type === "hour")?.value);
    const dayMap = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 0 };
    return (
      (config.supportHours?.days || []).includes(dayMap[weekday]) &&
      hour >= Number(config.supportHours?.startHour || 9) &&
      hour < Number(config.supportHours?.endHour || 17)
    );
  }

  function availabilityLabel() {
    if (isBusinessHours()) {
      return "Support hours now: Mon-Sat, 9 AM-5 PM PST";
    }
    return "Support replies by the next business day";
  }

  function track(eventName, detail) {
    const event = `${config.analytics?.namespace || "eom_chatbot"}_${eventName}`;
    const payload = { event, chatbot_event: eventName, ...(detail || {}) };

    if (config.analytics?.useDataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }

    if (config.analytics?.useGtag && typeof window.gtag === "function") {
      window.gtag("event", event, detail || {});
    }

    if (config.analytics?.useShopifyAnalytics && window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(event, detail || {});
    }
  }

  function buildMailto(subject, body, replyTo) {
    const to = config.supportEmail || "contact@earthonmall.com";
    const fullBody = replyTo ? `${body}\n\nCustomer email: ${replyTo}` : body;
    return `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(fullBody)}`;
  }

  function expandIcon(expanded) {
    if (expanded) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3v5H3"></path><path d="m3 3 5 5"></path><path d="M16 21v-5h5"></path><path d="m21 21-5-5"></path></svg>';
    }

    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6"></path><path d="m21 3-7 7"></path><path d="M9 21H3v-6"></path><path d="m3 21 7-7"></path></svg>';
  }

  function normalize(text) {
    return String(text || "").toLowerCase().replace(/\s+/g, " ").trim();
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();